import * as postVideoActions from '../../action_creators/post/post_video_action_creators';
import PostVideoModel from '../../../models/post/post_video_module';
import log from '../../../services/logger_service';
import { setAB } from '../../../utils/ab_test_util';

export default function fetchPostDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(postVideoActions.postVideoLoading({}, store));

    const state = store.getState();
    const { abtest } = state.config;

    return PostVideoModel.fetch(params, store)
      .then(function handlePostDetailData(resp) {
        const { data } = resp;
        Object.keys(data).forEach(key => {
          if (Array.isArray(data[key])) {
            setAB(data[key], abtest);
          }
        });

        dispatch(postVideoActions.postVideoLoaded(data, store));
      })
      .catch(function handleUserError(err) {
        dispatch(postVideoActions.postVideoLoadError(err, store));
        log.error(err, `Error in post video actions, message: ${err.message}`);
      });
  };
}
